"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETipoCalcJuros = exports.EMensalAgrupamento = exports.EFormaPgtoTipo = exports.EFormaPgto = exports.ENumeroCobradora = exports.ELocalPagamento = exports.ETipoConta = void 0;
var ETipoConta;
(function (ETipoConta) {
    ETipoConta["0001 - Matr\u00EDcula"] = "0001";
    ETipoConta["0002 - Mensalidade"] = "0002";
    ETipoConta["0003 - Material"] = "0003";
    ETipoConta["0004 - Depend\u00EAncia"] = "0004";
    ETipoConta["0005 - Diversos"] = "0005";
})(ETipoConta = exports.ETipoConta || (exports.ETipoConta = {}));
var ELocalPagamento;
(function (ELocalPagamento) {
    ELocalPagamento["Escola"] = "E";
    ELocalPagamento["Cobradora Padr\u00E3o"] = "B";
})(ELocalPagamento = exports.ELocalPagamento || (exports.ELocalPagamento = {}));
var ENumeroCobradora;
(function (ENumeroCobradora) {
    ENumeroCobradora["Escola"] = "001";
    ENumeroCobradora["Cobradora Padr\u00E3o"] = "002";
})(ENumeroCobradora = exports.ENumeroCobradora || (exports.ENumeroCobradora = {}));
var EFormaPgto;
(function (EFormaPgto) {
    EFormaPgto["Dinheiro"] = "01";
    EFormaPgto["Cheque"] = "02";
    EFormaPgto["Cart\u00E3o de Cr\u00E9dito"] = "03";
    EFormaPgto["Cart\u00E3o D\u00E9bito"] = "04";
    EFormaPgto["Boleto"] = "05";
    EFormaPgto["Outros"] = "99";
})(EFormaPgto = exports.EFormaPgto || (exports.EFormaPgto = {}));
var EFormaPgtoTipo;
(function (EFormaPgtoTipo) {
    EFormaPgtoTipo["Entrada"] = "ENTRADA";
    EFormaPgtoTipo["Anuidade"] = "ANUIDADE";
    EFormaPgtoTipo["Material"] = "MATERIAL";
})(EFormaPgtoTipo = exports.EFormaPgtoTipo || (exports.EFormaPgtoTipo = {}));
var EMensalAgrupamento;
(function (EMensalAgrupamento) {
    EMensalAgrupamento[EMensalAgrupamento["Padr\u00E3o"] = 0] = "Padr\u00E3o";
    EMensalAgrupamento[EMensalAgrupamento["Agrupar p/ Venc."] = 1] = "Agrupar p/ Venc.";
    EMensalAgrupamento[EMensalAgrupamento["Agrupar p/ Resp."] = 2] = "Agrupar p/ Resp.";
    EMensalAgrupamento[EMensalAgrupamento["N\u00E3o agrupar"] = 3] = "N\u00E3o agrupar";
})(EMensalAgrupamento = exports.EMensalAgrupamento || (exports.EMensalAgrupamento = {}));
var ETipoCalcJuros;
(function (ETipoCalcJuros) {
    ETipoCalcJuros["0) C\u00E1lculo de Juros Di\u00E1rio"] = " ";
    ETipoCalcJuros["2) C\u00E1lculo de Juros Mensal"] = "2";
    ETipoCalcJuros["3) \u00BD Multa at\u00E9 dia 15 + %Juros a cada m\u00EAs"] = "3";
    ETipoCalcJuros["4) 1,8% Multa ao m\u00EAs + Juros at\u00E9 30 dias"] = "4";
    ETipoCalcJuros["5) Juros M\u00EAs Cheio s/ Car\u00EAncia 1\u00BA M\u00EAs"] = "5";
    ETipoCalcJuros["6) \u00BD Multa de 6 a 10, Multa+0,05% mora + 1% M\u00EAs"] = "6";
    ETipoCalcJuros["7) Valor Fixo de juros para dias de atraso"] = "7";
    ETipoCalcJuros["8) 6 em Diante, Multa + 0,05% mora + 1% M\u00EAs"] = "8";
    ETipoCalcJuros["9) 5%, 4 dias=10%, >= 8 dias=12%"] = "9";
})(ETipoCalcJuros = exports.ETipoCalcJuros || (exports.ETipoCalcJuros = {}));
